/*LIBRARY*/
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import SpinnerSimpleBlue from "../common_spinner/SpinnerSimpleBlue";
import PINNED_BUTTON from "./PINNED_BUTTON";
import EDIT_PROJECT from "./EDIT_PROJECT";
import DeleteProject from "./DeleteProject";
import PROJECT_COLLAB from "./PROJECT_COLLAB";
import MOVE_PROJECT_TO_FOLDER from "./MOVE_PROJECT_TO_FOLDER";
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";
import Yes from "../../Assets/svg/tick-circle.svg";

/*REDUX*/
import {
  getProjectList,
  setProject,
  set_value_project,
} from "../../App/actions/projectActions";

/*PICTURE*/
import menu_icon from "../../Assets/svg/menu_icon.svg";

/*FUNCTION*/
import getStatusMember from "../../App/validation/get-status-member";
import formatDate from "../../App/validation/format-date";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const PROJECT_MODE_LIST = ({
  auth,
  project,
  title,
  getProjectList,
  setProject,
  set_value_project,
}) => {
  const [state, setState] = useState({
    modal_menu: false,
    modal_edit: false,
    modal_delete: false,
    modal_push_member: false,
    modal_move_folder: false,
    geo_project_id: "",
    sort_by: "date",
    sort_mode: "desc",
    skip: 0,
    limit: 6,
    status_user: "",
    anchor: null,
    roles: ["creator", "admin", "viewer", "contributor"],
    modal_roles_rules: false,
  });

  const {
    modal_menu,
    modal_edit,
    modal_delete,
    modal_push_member,
    modal_move_folder,
    modal_roles_rules,
    geo_project_id,
    skip,
    limit,
    status_user,
    anchor,
    roles,
  } = state;

  useEffect(() => {
    const screenW = window.screen.width;
    let limit = 10; // Different default for list view
    if (screenW > 1919) {
      limit = 20;
    } else if (screenW > 1499) {
      limit = 15;
    } else if (screenW > 1149) {
      limit = 12;
    }
    setState((prevState) => ({ ...prevState, limit }));
    if (project.geo_project_list.length === 0) {
      const params = {
        skip: state.skip,
        limit: limit,
      };
      getProjectList(params);
    }
  }, [getProjectList, project?.geo_project_list?.length, state?.skip]);

  const toggle_menu = async (event) => {
    try {
      if (event) {
        event.preventDefault();
        event.stopPropagation();

        const { user } = auth;
        const {
          geo_project_list,
          geo_project_list_child,
          folder_object_selected_list,
          geo_project_pinned_list,
        } = project;

        const geo_project_id = event?.currentTarget?.id;

        if (geo_project_id) {
          set_value_project({
            key: "project_id_selected_move",
            value: geo_project_id,
          });
        }

        let project_item = null;
        const project_list =
          folder_object_selected_list.length === 0
            ? geo_project_list
            : geo_project_list_child;

        if (title === "Pinned") {
          project_item = geo_project_pinned_list.find(
            (item) => item?._id === geo_project_id
          );
        } else {
          project_item = project_list.find(
            (item) => item?._id === geo_project_id
          );
        }

        const groups = project_item?.groups || [];
        const status_user = getStatusMember(groups, user?._id);

        if (project_item) {
          setProject(project_item);
        }

        setState((prevState) => ({
          ...prevState,
          anchor: event.currentTarget,
          geo_project_id,
          status_user,
          modal_menu: true,
        }));
      } else {
        setProject({});
        setState((prevState) => ({
          ...prevState,
          modal_menu: false,
          geo_project_id: "",
        }));
        set_value_project({
          key: "project_id_selected_move",
          value: "",
        });
      }
    } catch (error) {
      console.error("Error in toggle_menu:", error);
    }
  };

  const on_close_menu = () => {
    setState((prevState) => ({
      ...prevState,
      anchor: null,
      modal_menu: false,
    }));
  };

  const toggle_move_folder = () => {
    setState((prevState) => ({
      ...prevState,
      modal_move_folder: !prevState.modal_move_folder,
      modal_menu: false,
    }));
    if (modal_move_folder) {
      setState((prevState) => ({
        ...prevState,
        geo_project_id: "",
      }));
      setProject({});
    }
  };

  const toggle_edit_project = () => {
    setState((prevState) => ({
      ...prevState,
      modal_edit: !prevState.modal_edit,
      modal_menu: false,
    }));
    if (modal_edit) {
      setState((prevState) => ({
        ...prevState,
        geo_project_id: "",
      }));
      setProject({});
    }
  };

  const toggleDelete = () => {
    setState((prevState) => ({
      ...prevState,
      modal_delete: !prevState.modal_delete,
      modal_menu: false,
    }));
    if (modal_delete) {
      setState((prevState) => ({
        ...prevState,
        geo_project_id: "",
      }));
      setProject({});
    }
  };

  const toggle_push_member = () => {
    setState((prevState) => ({
      ...prevState,
      modal_push_member: !prevState.modal_push_member,
      modal_menu: false,
    }));

    if (modal_push_member) {
      setState((prevState) => ({
        ...prevState,
        geo_project_id: "",
      }));
      setProject({});
    }
  };

  const set_load_more_project = () => {
    const new_skip = skip + limit;
    const params = {
      skip: new_skip,
      limit,
      append: true,
      lastProject: project.geo_project_list,
    };
    getProjectList(params);
    setState((prevState) => ({
      ...prevState,
      skip: new_skip,
    }));
  };

  const rolesRule = () => {
    setState((prevState) => ({
      ...prevState,
      modal_roles_rules: !prevState.modal_roles_rules,
    }));
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //global props
  const {
    geo_project_list,
    geo_project_list_child,
    folder_object_selected_list,
    geo_project_pinned_list,
    loading_item_array,
    loadingList,
  } = project;
  const { user } = auth;
  const is_in_child_mode = folder_object_selected_list.length > 0 || false;
  const is_content_show = (!is_in_child_mode && title === "Pinned") || !title;

  //content
  let project_list_final = [];
  if (title === "Pinned") {
    project_list_final = geo_project_pinned_list || [];
  } else if (is_in_child_mode) {
    project_list_final = geo_project_list_child;
  } else {
    project_list_final = geo_project_list;
  }

  let content;

  if (
    project_list_final.length === 0 &&
    (loading_item_array.includes("get_project_list_by_folder_id") ||
      loadingList)
  ) {
    content = (
      <SpinnerSimpleBlue
        width={200}
        unik="loading_item_list"
        marginTop="0px"
        center={true}
        border={0.1}
      />
    );
  } else if (project_list_final.length === 0) {
    content = (
      <section
        className="container background_white"
        style={{ height: "100px", width: "200px" }}
      >
        <p className="text_medium sub_color">
          {dict?.["You don't have any map projects yet"]?.[language]}
        </p>
      </section>
    );
  } else {
    // Replace your existing table content section with this:

    content = (
      <div
        className="background_white outline_grey"
        style={{ borderRadius: "8px", overflow: "hidden" }}
      >
        {/* Add this wrapper div for horizontal scrolling */}
        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              minWidth: "800px",
            }}
          >
            <thead>
              <tr
                style={{
                  backgroundColor: "#f8f9fa",
                  borderBottom: "1px solid #e9ecef",
                }}
              >
                <th
                  style={{
                    padding: "12px 16px",
                    textAlign: "left",
                    fontSize: "14px",
                    fontWeight: "600",
                    minWidth: "150px", // Ensure minimum column width
                  }}
                >
                  {dict?.["Name"]?.[language]}
                </th>
                <th
                  style={{
                    padding: "12px 16px",
                    textAlign: "left",
                    fontSize: "14px",
                    fontWeight: "600",
                    minWidth: "100px",
                  }}
                >
                  {dict?.["Sharing"]?.[language]}
                </th>
                <th
                  style={{
                    padding: "12px 16px",
                    textAlign: "left",
                    fontSize: "14px",
                    fontWeight: "600",
                    minWidth: "120px",
                  }}
                >
                  {dict?.["Collaboration"]?.[language]}
                </th>
                <th
                  style={{
                    padding: "12px 16px",
                    textAlign: "left",
                    fontSize: "14px",
                    fontWeight: "600",
                    minWidth: "100px",
                  }}
                >
                  {dict?.["Created"]?.[language]}
                </th>
                <th
                  style={{
                    padding: "12px 16px",
                    textAlign: "left",
                    fontSize: "14px",
                    fontWeight: "600",
                    minWidth: "100px",
                  }}
                >
                  {dict?.["Modified"]?.[language]}
                </th>
                <th
                  style={{
                    padding: "12px 16px",
                    textAlign: "left",
                    fontSize: "14px",
                    fontWeight: "600",
                    minWidth: "120px",
                  }}
                ></th>
                <th
                  style={{
                    padding: "12px 16px",
                    textAlign: "center",
                    fontSize: "14px",
                    fontWeight: "600",
                    width: "50px",
                    minWidth: "50px",
                  }}
                ></th>
              </tr>
            </thead>
            <tbody>
              {project_list_final.map((geo_project, idx) => {
                const { name, isPublic, link, _id } = geo_project;
                const date_created = geo_project.date_created;
                const date = geo_project?.date;
                const public_or_private = isPublic ? "Public" : "Private";
                const groups = geo_project?.groups || [];
                let status_user = getStatusMember(groups, user?._id);
                let status_user_render;

                if (!status_user || status_user === "guest") {
                  status_user = "owner";
                  status_user_render = dict["Personal Project"][language];
                } else {
                  status_user_render =
                    status_user.charAt(0).toUpperCase() + status_user.slice(1);
                }

                return (
                  <tr
                    key={idx}
                    style={{
                      borderBottom: "1px solid #e9ecef",
                      backgroundColor:
                        _id === geo_project_id
                          ? "#e3f2fd"
                          : idx % 2 === 0
                          ? "#fff"
                          : "#fafafa",
                    }}
                  >
                    {/* Project Name */}
                    <td style={{ padding: "12px 16px" }}>
                      <div>
                        <p
                          className="text_bold"
                          style={{
                            margin: 0,
                            marginBottom: "4px",
                            fontSize: "14px",
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                          title={name}
                        >
                          {name}
                        </p>
                      </div>
                    </td>

                    {/* Status */}
                    <td style={{ padding: "12px 16px" }}>
                      <span
                        className={`badge_small ${
                          public_or_private === "Public"
                            ? "green_container"
                            : "grey_container"
                        }`}
                        style={{ fontSize: "12px", whiteSpace: "nowrap" }}
                      >
                        {public_or_private}
                      </span>
                    </td>

                    {/* Role */}
                    <td style={{ padding: "12px 16px" }}>
                      <button
                        onClick={rolesRule}
                        style={{
                          border: "none",
                          background: "none",
                          padding: 0,
                        }}
                      >
                        <span
                          className={`badge_small ${
                            ["owner"].includes(status_user)
                              ? "dark_blue_container"
                              : ["admin"].includes(status_user)
                              ? "green_container"
                              : ["creator"].includes(status_user)
                              ? "orange_container"
                              : ["contributor"].includes(status_user)
                              ? "blue_container"
                              : "grey_container"
                          }`}
                          style={{ fontSize: "12px", whiteSpace: "nowrap" }}
                        >
                          {status_user_render}
                        </span>
                      </button>
                    </td>

                    {/* Created Date */}
                    <td style={{ padding: "12px 16px" }}>
                      <p
                        className="text_small"
                        style={{
                          margin: 0,
                          fontSize: "12px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {date_created ? formatDate(date_created) : "-"}
                      </p>
                    </td>

                    {/* Modified Date */}
                    <td style={{ padding: "12px 16px" }}>
                      <p
                        className="text_small"
                        style={{
                          margin: 0,
                          fontSize: "12px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {date ? formatDate(date) : "-"}
                      </p>
                    </td>

                    {/* Actions */}
                    <td style={{ padding: "12px 16px", textAlign: "left" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          gap: "8px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {status_user !== "viewer" && (
                          <Link to={`/editor/${link}`}>
                            <button
                              className="button_small background_black"
                              style={{
                                padding: "4px 8px",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                fontSize: "12px",
                              }}
                              data-mapid={`clickEditor-${idx}`}
                            >
                              Editor
                            </button>
                          </Link>
                        )}

                        <Link to={`/view/${link}`}>
                          <button
                            className="button_small background_black"
                            style={{
                              padding: "4px 8px",
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              fontSize: "12px",
                            }}
                          >
                            Viewer
                          </button>
                        </Link>
                      </div>
                    </td>

                    {/* Menu */}
                    <td style={{ padding: "12px 16px", textAlign: "center" }}>
                      <button
                        onClick={toggle_menu}
                        onTouchStart={toggle_menu}
                        id={geo_project?._id}
                        className="button_small button_white"
                        style={{ padding: "4px 8px" }}
                        data-mapid={`${
                          title?.toLowerCase() || "basic"
                        }_${idx}_toggle`}
                      >
                        <img alt="menu" src={menu_icon} height={12} />
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  const modal_roles_rules_content = modal_roles_rules && (
    <Modal modalSize="medium" isOpen={modal_roles_rules} onClose={rolesRule}>
      <div style={{ overflowX: "auto" }}>
        <h2 style={{ marginBottom: "20px", fontFamily: "sans-serif" }}>
          Aturan Role Grup
        </h2>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontFamily: "sans-serif",
            fontSize: "14px",
          }}
        >
          <thead>
            <tr style={{ background: "#f5f5f5", textAlign: "left" }}>
              <th style={{ padding: "10px", border: "1px solid #ddd" }}></th>
              {roles.map((dt, index) => {
                return (
                  <th
                    key={index}
                    style={{ padding: "10px", border: "1px solid #ddd" }}
                  >
                    <p
                      className={`badge margin_bottom ${
                        ["owner"].includes(dt)
                          ? "dark_blue_container"
                          : ["admin"].includes(dt)
                          ? "green_container"
                          : ["creator"].includes(dt)
                          ? "orange_container"
                          : ["contributor"].includes(dt)
                          ? "blue_container"
                          : "grey_container"
                      }`}
                    >
                      {dt}
                    </p>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {[
              [
                dict?.["Deleting a group"]?.[language],
                "ya",
                "tidak",
                "tidak",
                "tidak",
              ],
              [
                dict?.["Rename a group"]?.[language],
                "ya",
                "tidak",
                "tidak",
                "tidak",
              ],
              [
                dict?.["Adding members to a group"]?.[language],
                "ya",
                "ya",
                "tidak",
                "tidak",
              ],
              [
                dict?.["Changing member roles in a group"]?.[language],
                "ya",
                "tidak",
                "tidak",
                "tidak",
              ],
              [
                dict?.["Delete member"]?.[language],
                "ya",
                "ya",
                "tidak",
                "tidak",
              ],
              [""], // pemisah
              [
                dict?.["Adding a group to a project"]?.[language],
                "ya",
                "ya",
                "tidak",
                "tidak",
              ],
              [
                dict?.["View the collaborative project editor map"]?.[language],
                "ya",
                "ya",
                "ya",
                "tidak",
              ],
              [
                dict?.["View the collaborative project map viewer"]?.[language],
                "ya",
                "ya",
                "ya",
                "ya",
              ],
              [
                dict?.["Submit the form in the collaboration project"]?.[
                  language
                ],
                "ya",
                "ya",
                "ya",
                "ya",
              ],
            ].map((row, idx) =>
              row.length === 1 && row[0] === "" ? (
                <tr key={idx}>
                  <td
                    colSpan={5}
                    style={{ background: "#eee", height: "10px", padding: 0 }}
                  />
                </tr>
              ) : (
                <tr
                  key={idx}
                  style={{
                    background: idx % 2 === 0 ? "#fff" : "#fafafa",
                  }}
                >
                  {row.map((col, cIdx) => (
                    <td
                      key={cIdx}
                      style={{
                        padding: "10px",
                        border: "1px solid #ddd",
                        textAlign: "center",
                      }}
                    >
                      {col === "ya" ? (
                        <img src={Yes} alt="yes" width={20} />
                      ) : col === "tidak" ? (
                        "-"
                      ) : (
                        col
                      )}
                    </td>
                  ))}
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
    </Modal>
  );

  const modal_menu_content = (
    <FLOAT_MENU
      id="basic-menu"
      anchorEl={anchor}
      open={modal_menu}
      onClose={toggle_menu}
    >
      <div>
        {status_user === "creator" ||
        status_user === "admin" ||
        status_user === undefined ||
        status_user === "owner" ||
        status_user === "guest" ? (
          <>
            <PINNED_BUTTON on_close_menu={on_close_menu} />
            <br />
            <button
              className="button_big margin_bottom button_white"
              onClick={toggle_edit_project}
              data-mapid="clickEdit"
            >
              {dict["Edit"][language]}
            </button>
            <br />
            <button
              className="button_big margin_bottom button_white"
              onClick={toggle_push_member}
              data-mapid="clickColabolator"
            >
              {dict?.["Collaboration"]?.[language]}
            </button>
            <br />
            <button
              className="button_big margin_bottom button_white"
              onClick={toggle_move_folder}
              data-mapid="clickMove"
            >
              {dict?.["Move to folder"]?.[language]}
            </button>
            <br />
            <button
              className="button_big button_white"
              onClick={toggleDelete}
              data-mapid="clickDelete"
            >
              {dict["Delete"][language]}
            </button>
          </>
        ) : (
          <>
            <PINNED_BUTTON on_close_menu={on_close_menu} />
            <br />
            <button
              className="button_big margin_bottom button_white"
              onClick={toggle_push_member}
            >
              {dict["Collaboration"][language]}
            </button>
            <br />
            <button
              className="button_big button_white"
              onClick={toggle_move_folder}
            >
              {dict?.["Move to folder"]?.[language]}
            </button>
          </>
        )}
      </div>
    </FLOAT_MENU>
  );

  const modal_edit_content = modal_edit && (
    <Modal
      modalSize="medium"
      id="modal"
      isOpen={modal_edit}
      onClose={toggle_edit_project}
    >
      <div className="box-body">
        <EDIT_PROJECT toggle_edit_project={toggle_edit_project} title={title} />
      </div>
    </Modal>
  );

  const modal_delete_content = modal_delete && (
    <Modal
      modalSize="small"
      id="modal"
      isOpen={modal_delete}
      onClose={toggleDelete}
    >
      <div className="box-body">
        <DeleteProject toggleDelete={toggleDelete} title={title} />
      </div>
    </Modal>
  );

  const modal_push_member_content = modal_push_member && (
    <Modal
      modalSize="medium"
      isOpen={modal_push_member}
      onClose={toggle_push_member}
    >
      <div className="box-body">
        <PROJECT_COLLAB />
      </div>
    </Modal>
  );

  const modal_move_folder_content = modal_move_folder && (
    <Modal
      modalSize="medium"
      id="modal"
      isOpen={modal_move_folder}
      onClose={toggle_move_folder}
    >
      <div className="box-body">
        <MOVE_PROJECT_TO_FOLDER toggle_move_folder={toggle_move_folder} />
      </div>
    </Modal>
  );

  const load_more_content = (
    <div style={{ marginTop: 24, textAlign: "center" }}>
      {project.loadMoreBtn ? (
        <button
          className="button_big button_white"
          onClick={() => set_load_more_project()}
          disabled={project.loadMoreBtnLoading}
        >
          {dict["Load more"][language]}
        </button>
      ) : (
        <p>{dict["All Projects Shown"][language]}</p>
      )}
    </div>
  );

  return (
    <div>
      {modal_menu_content}
      {modal_roles_rules_content}
      {modal_edit_content}
      {modal_delete_content}
      {modal_push_member_content}
      {modal_move_folder_content}
      {is_content_show && (
        <>
          <h3 className="text_big margin_bottom">
            {dict?.[title || "Projects"]?.[language]}
            {title === "Pinned" &&
              ` ${project_list_final?.length || 0} ${
                dict["of 10 projects"][language]
              }`}
          </h3>
          {content}
          {title !== "Pinned" && load_more_content}
        </>
      )}
      {title === "Pinned" && (
        <hr
          style={{
            width: "100%",
            height: "4px",
            backgroundColor: "#a5a5a5",
            border: "none",
            borderRadius: "4px",
          }}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  project: state.project,
});

export default connect(mapStateToProps, {
  getProjectList,
  setProject,
  set_value_project,
})(PROJECT_MODE_LIST);
